import React, { useState, useEffect } from "react";
import {
  Input,
  Switch,
  UpgradeCard,
  UploadFile,
} from "../../../components";
import { useNavigate, useLocation } from "react-router-dom";
import ROUTES from "../../constants/routes";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { connect, useSelector } from "react-redux";
import Slide from "@mui/material/Slide";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  sendSingleInvite,
  bulkInvites,
  validateInvitaion,
  saveTemplate,
} from "../../../redux/actions/standard/homeActions";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CSVLink } from "react-csv";
import Papa from "papaparse";
import Dialog from "@mui/material/Dialog";

import { InformationCircleIcon } from "@heroicons/react/solid";
import { PencilIcon } from "@heroicons/react/solid";

// get step data from redux main state
const data = (state) => state.standardHome;
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
let Invite = (props) => {
  const [copied, setCopied] = useState(false);
  const [gameLock, setGameLock] = useState(false);
  const [bulkInvite, setBulkInvite] = useState(false);
  const [bulkInviteEmails, setBulkInviteEmails] = useState("");
  const [bulkInviteFileName, setBulkInviteFileName] = useState("");
  const [upgrade, setUpgrade] = useState(false);
  const [bulkErrMessage, setBulkErrMessage] = useState("");
  const [errMessage] = useState("");
  const [dummyEmails] = useState([["Email Address"]]);
  const [open, setopen] = React.useState(false);
  const [campaignEmail, setCampaignEmail] = useState("");
  const [emailSubject, setEmailSubject] = useState();
  const [message, setMessage] = useState();
  const [editorState, setEditorState] = useState("");
  let navigate = useNavigate();
  const { state } = useLocation();

  let allData = useSelector(data);

  // handleVisitDashboard
  let handleVisitDashboard = () => {
    navigate(`${ROUTES.DASHBOARD}`, { replace: true });
  };

  const { url, campaignId } = state;

  const emailSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email address").required("Required"),
  });

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: emailSchema,
    onSubmit: (values) => {
      let email = values.email;
      props.sendSingleInvite(email, campaignId);
    },
  });

  let onCloseUpgrade = () => {
    setUpgrade(!upgrade);
  };

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  let uploadBulkInvites = (event) => {
    let file = event.target.files[0];
    if (/\.(csv)$/i.test(file.name)) {
      Papa.parse(file, {
        header: false,
        skipEmptyLines: true,
        complete: async (data) => {
          let results = data.data;
          var isMatch = false;
          var valuesArray = [];
          console.log(results.data, "ssss");
          if (results.length > 1) {
            results.map((item, index) => {
              if (index !== 0) {
                if (validateEmail(item[0])) {
                  valuesArray.push({
                    name: item[0],
                  });
                } else {
                  isMatch = true;
                  setBulkErrMessage(
                    `One of the cells has incorrect email address`
                  );
                  setTimeout(() => {
                    setBulkErrMessage("");
                  }, 7000);
                }
              }
            });

            if (isMatch) {
              valuesArray = [];
              setBulkInviteEmails(valuesArray);
              setBulkInviteFileName();
            }

            if (valuesArray.length > 0) {
              let count = await validateInvitaion(campaignId);
              if (count >= valuesArray.length) {
                setBulkInviteFileName(file.name);
                setBulkInviteEmails(valuesArray);
              } else {
                setBulkErrMessage(
                  "You cannot upload a file that contains more than 300 email addresses. Please edit the .csv file and upload again."
                );
                setTimeout(() => {
                  setBulkErrMessage("");
                }, 7000);
              }
            }
          } else {
            setBulkErrMessage("No emails found.");
            setBulkInviteFileName("");
            setBulkInviteEmails([]);
            setTimeout(() => {
              setBulkErrMessage("");
            }, 7000);
          }
        },
      });
    } else {
      setBulkErrMessage("You can't upload this type of file.");
      setTimeout(() => {
        setBulkErrMessage("");
      }, 7000);
    }

    event.target.value = "";
  };

  let bulkInvitesHandle = () => {
    props.bulkInvites(campaignId, bulkInviteEmails);
    setTimeout(() => {
      setBulkInviteFileName("");
      setBulkInviteEmails([]);
    }, 3500);
  };

  useEffect(() => {
    if (allData.succesMessage) {
      formik.resetForm(); // reset form after submit
    }
  }, [allData]);

  // update Plan

  let updatePlan = () => {
    setUpgrade(!upgrade);
  };

  let saveEmailTemplate = () => {
    let settings = {
      campaignEmail: campaignEmail,
      emailSubject: emailSubject,
      emailTemplate: editorState,
    };
    props.saveTemplate(campaignId, settings);
    setTimeout(() => {
      props.updateGetTemplateData(campaignId);
      setopen(false)
    }, 1000);
  };
  let { currentType } = props;

  useEffect(() => {
    let emailTemplateData = props?.templateData;
    let { emailTemplate, emailSubject, campaignEmail } = emailTemplateData;
    setEditorState(emailTemplate);
    setEmailSubject(emailSubject);
    setCampaignEmail(campaignEmail);
    setMessage(emailTemplate);
  }, [props]);

  return (
    <div>
      {upgrade ? (
        <UpgradeCard type="PREMIUM" onCloseUpgrade={onCloseUpgrade} />
      ) : (
        <div className="2xl:w-7/12 xl:w-7/12 lg:w-7/12 w-10/12 mx-auto">
          <Dialog
            onBackdropClick={() => setopen(false)}
            sx={{
              "& .MuiPaper-root": {
                borderWidth: 3, // Set the desired border width
                borderStyle: "solid",
                borderColor: "#007E8C", // Set the desired border color
              },
            }}
            open={open}
            TransitionComponent={Transition}
            keepMounted
            aria-describedby="alert-dialog-slide-description2"
          >
            <div className="px-10 ">
              <div className="pt-10">
                <div>
                  <p className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-6">
                    Email Template
                  </p>
                  <ReactQuill
                    name="emailTemplate"
                    value={editorState}
                    onChange={(state) => setEditorState(state)}
                    defaultValue={message}
                    style={{ height: 240, marginBottom: 50 }}
                  />
                </div>
              </div>
              <div className="mb-8 flex flex-col justify-center items-center">
                {allData && allData.succesTemplateMessage ? (
                  <div>
                    <span className="text-green-600 text-sm font-semibold">
                      {allData.succesTemplateMessage}
                    </span>
                  </div>
                ) : null}
                <button
                  onClick={() => saveEmailTemplate()}
                  className={`bg-[#007E8C] w-[15rem] text-[white] font-semibold mt-[1rem]  px-6 py-2  text-lg leading-normal capitalize rounded shadow-md`}
                >
                  {allData.temploading ? "Please Wait" : "Save"}
                </button>
              </div>
            </div>
          </Dialog>

          <div className="mainHeading flex justify-center mt-[2rem]">
            <h1 className="text-5xl text-[#007E8C] font-bold">
              INVITE YOUR CANDIDATES
            </h1>
          </div>
          <div className="flex flex-row justify-around items-start  bg-white rounded-md shadow-lg border mt-10 border-gray-600 py-[2rem] mb-4">
            <div className="w-5/12">
              <p className="text-xl color-[#333333] font-semibold my-4">
                Single Email Invite
              </p>
              <div className="inputSection">
                <form onSubmit={formik.handleSubmit} noValidate>
                  <Input
                    {...formik.getFieldProps("email")}
                    label="Email"
                    placeholder="Type email address here"
                    type="email"
                    name="email"
                    autoComplete="off"
                  />
                  {formik.touched.email &&
                  formik.errors.email &&
                  !errMessage ? (
                    <div>
                      <span className="text-red-600 text-sm font-semibold">
                        {formik.errors.email}
                      </span>
                    </div>
                  ) : null}

                  {errMessage ? (
                    <div>
                      <span className="text-red-600 text-sm font-semibold">
                        {errMessage}
                      </span>
                    </div>
                  ) : null}

                  {allData && allData.succesMessage ? (
                    <div>
                      <span className="text-green-600 text-sm font-semibold">
                        {allData.succesMessage}
                      </span>
                    </div>
                  ) : null}

                  <button
                    type="submit"
                    disabled={allData.loading ? true : false}
                    className={`bg-[#FFD700] text-[#4F4F4F] font-semibold mt-[1rem] w-full px-6 py-2  text-lg leading-normal capitalize rounded shadow-md`}
                  >
                    {allData.loading ? "Please Wait" : "Invite"}
                  </button>
                </form>

                {bulkInvite ? (
                  <div>
                    <div className="mt-6">
                      <UploadFile
                        customStyles="font-bold text-xl"
                        color="#333333"
                        imgSize=".csv, text/csv"
                        accept=".csv, text/csv"
                        value={bulkInviteFileName}
                        title="Please upload .csv file only (Max 300 email invites allowed)"
                        onChange={(event) => {
                          console.log(event, "s");
                          uploadBulkInvites(event);
                        }}
                      />
                      {bulkErrMessage ? (
                        <div>
                          <span className="text-red-600 text-sm -mt-6 font-semibold">
                            {bulkErrMessage}
                          </span>
                        </div>
                      ) : null}

                      {allData && allData.bulkSuccesMessage ? (
                        <div>
                          <span className="text-green-600 my-2 text-sm font-semibold">
                            {allData.bulkSuccesMessage}
                          </span>
                        </div>
                      ) : null}
                      <div className="my-2">
                        <CSVLink
                          filename={"Email Invitaion.csv"}
                          data={dummyEmails}
                          className="text-[#007E8C] font-normal text-sm"
                        >
                          Download Sample File
                        </CSVLink>
                      </div>
                    </div>
                    <div>
                      <button
                        type="submit"
                        className={`text-[#4F4F4F] font-semibold mt-[1rem] w-full px-6 py-2  text-lg leading-normal capitalize rounded shadow-md ${
                          bulkInviteEmails.length > 0
                            ? "bg-[#FFD700]"
                            : "bg-gray-400 text-[white]  hover:bg-bg-gray-400"
                        }  
                    `}
                        onClick={() => bulkInvitesHandle()}
                        disabled={bulkInviteEmails.length > 0 ? false : true}
                      >
                        {allData?.bulkloading
                          ? "Please Wait.."
                          : "Send Bulk Invites"}
                      </button>
                    </div>
                  </div>
                ) : null}

                {bulkInvite ? null : (
                  <button
                    onClick={() => setBulkInvite(true)}
                    className="bg-[#007E8C] text-[#FFFFFF] font-semibold mt-[1rem] w-full px-6 py-2  text-lg leading-normal capitalize rounded shadow-md "
                  >
                    Bulk Invite
                  </button>
                )}

                <button
                  type="button"
                  onClick={() => setopen(true)}
                  className={`bg-[#FFD700] text-[#4F4F4F] font-semibold mt-[1rem] w-full px-6 py-2  text-lg leading-normal capitalize rounded shadow-md flex flex-row justify-center items-center`}
                >
                  <span>Edit Your Email Invite</span>
                  <PencilIcon className="h-5 w-5 ml-4 inline-block" />
                </button>
              </div>
            </div>

            <div className="w-5/12">
              <div className="flex flex-row  items-center">
                <p className="text-xl font-semibold py-4">
                  Generate Your Link{" "}
                </p>
              </div>
              <p className="text-base">Enable to generate your Game Link </p>
              <Switch
                label="Game Link"
                checked={gameLock}
                onChange={() => setGameLock(!gameLock)}
              />
              {gameLock ? (
                <div className="flex flex-col mt-6 font-medium">
                  <h5 className="text-[#252B42]">
                    Game URL has been activated.
                  </h5>
                  <div className="mt-5">
                    <div className="relative">
                      <input
                        disabled={true}
                        type="text"
                        value={"https://" + url + ".thetalent.games"}
                        placeholder="www.game.com/talentgames/"
                        className="h-12 appearance-none w-full border px-4 rounded-md z-0 shadow outline-none"
                      />
                      <CopyToClipboard
                        text={"https://" + url + ".thetalent.games"}
                        onCopy={() => {
                          setCopied(true);
                          setTimeout(() => {
                            setCopied(false);
                          }, 1500);
                        }}
                      >
                        <div className="absolute top-0  right-0">
                          <button className="h-12  px-4 text-black  bg-[#E6E6E6]">
                            {copied ? "Copied" : "Copy"}
                          </button>
                        </div>
                      </CopyToClipboard>
                    </div>
                  </div>
                </div>
              ) : null}

              <button
                onClick={handleVisitDashboard}
                className="bg-[#007E8C] text-[white] font-semibold mt-[1rem] w-full px-6 py-2 2xl:mx-0 xl:mx-0 lg:mx-0 md:mx-0 mx-10 text-lg leading-normal capitalize rounded shadow-md "
              >
                Visit Dashboard
              </button>
              <div className="flex my-4  justify-end items-start">
                <InformationCircleIcon
                  data-tip={`Choose whether you want candidates to use their LinkedIn accounts to log in or their email addresses`}
                  data-for="inCandidateVideo"
                  className="text-[#007E8C] w-20 h-20 rounded-full -mt-[1.8rem] "
                />
                <p className="ml-2 text-left text-[#333333] font-thin">
                  Your assessment game will be live within 30-45 minutes. So, we
                  encourage you send out email invites after 30 minutes to
                  ensure a better candidate experience.
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-row justify-between items-center my-10 ">
            <div></div>
            <div className="text-center ml-10">
              <h1 className="font-normal text-xl  text-[#333333]">
                Your Current Plan:{" "}
                <b className="font-semibold uppercase text-[#007E8C]">
                  {currentType && currentType}
                </b>
              </h1>

              {currentType === "free" || currentType === "standard" ? (
                <button
                  onClick={() => updatePlan()}
                  className="font-medium underline text-[#007E8C] mt-2"
                >
                  Upgrade Your Plan
                </button>
              ) : null}
            </div>
            <div></div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  sendSingleInvite,
  bulkInvites,
  validateInvitaion,
  saveTemplate,
})(Invite);
